import React from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';

function useRequestsWOAccessToken() {
  const postRequestWOAccessToken = async (apiName, jsonpar) => {
    const headers = {
      'Content-Type': 'application/json',
      'app-token': process.env.REACT_APP_TOKEN_SECRET,
    };
console.log(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
        { data: CryptoJS.AES.encrypt(jsonpar, process.env.REACT_APP_ADMIN_TOKEN_SECRET).toString() },
        { headers: headers }
      );

      const res = response.data;

      if (res.code === 200) {
        if (res.data) {
          const bytes = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_ADMIN_TOKEN_SECRET);
          const originalText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          return {
            code: res.code,
            status: res.status,
            message: res.message,
            data: originalText,
          };
        } else {
          return {
            code: res.code,
            status: res.status,
            message: res.message,
            data: [],
          };
        }
      } else {
        return {
          code: res.code,
          status: res.status,
          message: res.message,
          data: [],
        };
      }
    } catch (error) {
      console.error('Error:', error);
      return {
        code: 401,
        status: 'ERROR',
        message: error.message,
        data: [],
      };
    }
  };

  return { postRequestWOAccessToken };
}

export default useRequestsWOAccessToken;